import React from 'react';
import { useSystemEvents } from '../hooks/use-system-events.js';
import SystemEventsPageView from './system-events-page-view.jsx';

function SystemEventsPageContainer() {
  const state = useSystemEvents();

  return <SystemEventsPageView {...state} />;
}

export default SystemEventsPageContainer;
